import './stage.scss';

import './stage.scss';

class Stage {
    constructor (element) {
        this.$stage = element;
        this.$content = this.$stage.querySelector('[data-stage="content"]');
        this.$stageContainer = this.$stage.querySelector('.stage__container');
        this.$stageImage = this.$stage.querySelector('[data-stage="image"] img');
        this.doContentParallax = false;
        this.observer = null;
        this.observerStartet = false;
        this.parallaxValues = {
            media: 0.25,
            content: 0.15
        };
    }

    initialize () {
        if (this.$stageImage) {
            this.setEvents();

            this.doContentParallax = window.mediaMatchHandler[1024].matches;

            if (this.$stageImage && this.$stage.dataset.stageParallax !== undefined) {
                this.setParallaxValue();
                this.startObserver();
            }
        }
    }

    setParallaxValue (remove = false) {
        let scrollPosition = window.scrollY;
        let stageImageHeight = this.$stageImage.offsetHeight;

        if (scrollPosition > stageImageHeight) {
            this.$stageImage.style.transform = '';
            if (this.doContentParallax) {
                this.$content.style.transform = '';
            }
            return;
        }

        this.$stageImage.style.transform = `translateY(${scrollPosition * this.parallaxValues.media}px)`;

        if (this.doContentParallax) {
            this.$content.style.transform = `translateY(${scrollPosition * this.parallaxValues.content}px)`;
        }

        if (remove) {
            this.$content.style.transform = '';
        }
    }

    startObserver () {
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    window.addEventListener("scroll", handleParallax);
                } else {
                    window.removeEventListener("scroll", handleParallax);
                }
            });
        }, { threshold: 0 });

        this.observer.observe(this.$stageImage);
        this.observerStartet = true;

        const handleParallax = () => {
            this.setParallaxValue();
        };
    }

    setEvents () {
        if (this.$stage.dataset.stageParallax !== undefined) {
            window.mediaMatchHandler[1024].addEventListener('change', (match) => {
                if (match.matches) {
                    this.doContentParallax = true;

                    if (!this.observerStartet) {
                        this.startObserver();
                    }

                    this.setParallaxValue();
                } else {
                    this.doContentParallax = false;
                    this.setParallaxValue(true);
                }
            });
        }
    }
}

export { Stage };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$stages = $context.querySelectorAll('[data-stage="root"]');
        $$stages.forEach(($stage) => {
            const stage = new Stage($stage);
            stage.initialize();
        });
    }
});
